export default __webpack_public_path__ + "static/media/deuka.390b6b65.svg";